import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import firebase from '../Configs/firebase'
import './Css/MainHeader.css';

class MainHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileMenuExpanded: false,
            isUserMenuExpanded: false
        };
        this.toggleHamburger = this.toggleHamburger.bind(this);
        this.handleLogout = this.handleLogout.bind(this)
    }

    toggleHamburger() {
        this.setState((prevState) => ({
            isMobileMenuExpanded: !prevState.isMobileMenuExpanded
        }));
    }

    handleLogout(){
        return firebase.auth().signOut()
    }

    render() {
        const { isMobileMenuExpanded } = this.state;
        const { isTransparent, user } = this.props;

        var navbarClasses = "MainHeader navbar is-transparent is-fixed-top";
        if ( isTransparent === true ) {
            navbarClasses += " BgTransparent";
        }

        var navBarMenuClasses = "navbar-menu";
        if ( isMobileMenuExpanded === true ) {
            navBarMenuClasses += " is-active";
        }

        var navBarMenuUser = <Link to="/login" className="button is-primary is-rounded is-outlined" >เข้าสู่ระบบ</Link>
        
        if( user !== null && user !== undefined){
            
            var userPhoto = <img src="/Images/profile@3x.png" alt="User"></img>
            if(user.photoURL !== null){
                userPhoto = <img src={user.photoURL} alt="User" ></img>
            }
            
            navBarMenuUser =    <div className="dropdown">
                                    <button className="dropbtn">{userPhoto}</button>
                                    <div className="dropdown-content">
                                        <Link className="is-primary" to="/gis">จัดการข้อมูล GIS</Link>
                                        <a onClick={this.handleLogout}>ออกจากระบบ</a>
                                    </div>
                                </div>
        }

        return (
            <nav className={navbarClasses} aria-label="main navigation">
                <div className="navbar-brand">
                    <Link className="MainHeaderBrandLink" to="/">
                        <img className="MainHeaderBrandLogo" src="/Images/logo.svg" alt="Ling" width="64" height="64" />
                        <h1 className="MainHeaderBrandTitle title has-text-white is-size-4 is-size-5-mobile">Ling Maps</h1>
                    </Link>
                    <div role="button" className="MainHeaderBurger navbar-burger" aria-label="menu" aria-expanded={isMobileMenuExpanded === true} onClick={this.toggleHamburger}>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </div>
                </div>
                <div className={navBarMenuClasses}>
                    <div className="navbar-end">
                        <div className="navbar-item">
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSemtB8N8M40S1jCvN_vDCIrEeXpZ7Stjo4tS-4-ggR9xwoPag/viewform" className="has-text-white" target="_blank" rel="noopener noreferrer">สั่งซื้อภาพโดรน</a>
                        </div>
                        <div className="navbar-item">
                            <Link to="/mymap">สร้างแผนที่</Link>
                        </div>
                        <div className="navbar-item">
                            {navBarMenuUser}
                        </div>
                    </div>
                </div>
                
            </nav>
        );
    }
}

export default MainHeader;


// WEBPACK FOOTER //
// ./src/Components/MainHeader.js